<template>
  <div>
    <app-title>Sign On Glass Partner Management</app-title>
    <v-container fluid grid-list-md>
      <v-dialog v-model="isDataLoading" hide-overlay persistent width="300">
        <v-card color="primary" dark>
          <v-card-text
            >Please Stand By <br />Data being loaded
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-layout row>
        <!-- <v-flex xs12 v-if="chartData">
          <orders-chart
            style="height: 100%; position: 'relative'"
            :chart-data="ordersChart"
            :options="ordersChart.options"
          ></orders-chart>
        </v-flex> -->
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions: mapHomeChartActions } = createNamespacedHelpers(
  `homeChart`
);

import ordersChart from "@/components/customer/orders-chart";
export default {
  name: "home",
  props: ["userProfile", "isAuthenticated"],
  components: {
    ordersChart
  },
  data() {
    return {
      chartData: null,
      isDataLoading: true
    };
  },
  methods: {
    ...mapHomeChartActions(["gethomeChart"])
  },
  computed: {
    ordersChart() {
      return {
        type: "line",
        fill: true,
        datasets: this.chartData.datasets,
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            xAxes: [
              {
                type: "time",
                distribution: "linear",
                displayFormats: {
                  month: "MMM YY"
                },
                time: {
                  unit: "month",
                  bounds: "data"
                }
              }
            ]
          }
        }
      };
    }
  },
  mounted() {
    this.isDataLoading = false;
    // let vm = this;
    // vm.gethomeChart({
    //   startDate: new Date(new Date().getFullYear(), 0, 1),
    //   endDate: new Date()
    // })
    //   .then(data => {
    //     vm.chartData = data;
    //     vm.isDataLoading = false;
    //   })
    //   .catch(() => {});
  }
};
</script>

<style scoped>
.small {
  max-width: 100%;
  margin: 10px auto;
}
</style>
